import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=7685d0f8&scoped=true&"
import script from "./CustomerLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=7685d0f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685d0f8",
  null
  
)

export default component.exports